import { progressTrackerQueryKeys } from './progressTrackerQueryKeys';
import { ProgressTrackerSetting } from './useFetchProgressTrackerSettings';
import { useFetchMutation } from '@opengov/bnp-core';

export type ProgressTrackerSettingsRequest = {
  entityId: number;
  settings: Array<{
    status: string;
    colorCode: string;
  }>;
};

export type IProgressTrackerUpdateResponse = {
  success: boolean;
  message: string;
  data: ProgressTrackerSetting[];
};

export function useUpdateProgressTrackerSettings(entityId: number) {
  return useFetchMutation<IProgressTrackerUpdateResponse, ProgressTrackerSettingsRequest>({
    mutationKey: progressTrackerQueryKeys.settings(entityId),
    url: `/api/stories/v1/progressTrackerSettings`
  });
}
